function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "ICON_GREY_PLUS_svg__cls-1",
  d: "M28.5 0v21.5H50v7H28.5V50h-7V28.5H0v-7h21.5V0h7z"
});

function SvgIconGreyPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 50 50"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PC9kZWZzPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIyOC41IDAgMjguNSAyMS41IDUwIDIxLjUgNTAgMjguNSAyOC41IDI4LjUgMjguNSA1MCAyMS41IDUwIDIxLjUgMjguNSAwIDI4LjUgMCAyMS41IDIxLjUgMjEuNSAyMS41IDAgMjguNSAwIi8+PC9zdmc+";
export { SvgIconGreyPlus as ReactComponent };